import { ButtonGroup } from "../buttons/button-group";
import { getDataTestId } from "../functions/data-test-ids";
import { CloseButton } from "../buttons/close-button";
import "./sidebar.css";

function SidebarHeader(props) {
    if (!props.Visible) {
        return null;
    }

    return (
        <div className="pd-sidebar-header-container">
            <div className="pd-sidebar-header">
                <div className="pd-sidebar-header-section">
                    <ButtonGroup Buttons={props.PreTitleButtons} />
                    <div className="pd-sidebar-header-title">{props.Title}</div>
                </div>
                <div className="pd-sidebar-header-section">
                    <ButtonGroup Buttons={props.Buttons} />
                    <CloseButton
                        Visible={!props.HideClose}
                        Close={props.Close}
                        DataTestId={getDataTestId(props.DataTestId, "close")} />
                </div>
            </div>
        </div>
    );
}

function Sidebar(props) {
    return (
        <div className="pd-sidebar">
            <SidebarHeader
                Visible={!props.HideHeader}
                DataTestId={props.DataTestId}
                Title={props.HeaderTitle}
                Close={props.Close}
                Buttons={props.HeaderButtons}
                PreTitleButtons={props.PreTitleButtons}
                HideClose={props.HideClose} />
            <div className={props.NoBodyPadding ? "pd-sidebar-body pd-sidebar-body-no-padding" : "pd-sidebar-body"}>
                {props.children}
            </div>
        </div>
    );
}

export { Sidebar, SidebarHeader };